import React, { useRef, useState } from 'react';
import useMediaQuery from '@mui/material/useMediaQuery';
import PropTypes from 'prop-types';
import { styled } from '@mui/material/styles';
import Dialog from '@mui/material/Dialog';
import DialogTitle from '@mui/material/DialogTitle';
import DialogContent from '@mui/material/DialogContent';
import DialogActions from '@mui/material/DialogActions';
import IconButton from '@mui/material/IconButton';
import CloseIcon from '@mui/icons-material/Close';
import { useTheme } from '@emotion/react';
import { Avatar, Button, Grid, Paper, Table, TableBody, TableCell, TableContainer, TableHead, TableRow, Typography } from '@mui/material';
import { useTranslation } from 'react-i18next';
import { Stack } from 'react-bootstrap';
import QRCode from 'react-qr-code';
import NumberInput from 'src/components/Input/NumberInput';
import ButtonAction from 'src/components/Button.js/SaveButton';
import Iconify from 'src/components/iconify';

const BootstrapDialog = styled(Dialog)(({ theme }) => ({
    '& .MuiDialogContent-root': {
        padding: theme.spacing(2),
    },
    '& .MuiDialogActions-root': {
        padding: theme.spacing(1),
    },
}));

function BootstrapDialogTitle(props) {
    const { children, onClose, ...other } = props;

    return (
        <DialogTitle sx={{ m: 0, p: 2 }} {...other}>
            {children}
            {onClose ? (
                <IconButton
                    aria-label="close"
                    onClick={onClose}
                    sx={{
                        position: 'absolute',
                        right: 8,
                        top: 8,
                        color: (theme) => theme.palette.grey[500],
                    }}
                >
                    <CloseIcon />
                </IconButton>
            ) : null}
        </DialogTitle>
    );
}

BootstrapDialogTitle.propTypes = {
    children: PropTypes.node,
    onClose: PropTypes.func.isRequired,
};

const PrintsQRCodeModal = ({visible=false, setVisible, data}) => {
    const { t } = useTranslation();
    const [quantity, setQuantity] = useState(1);
    const quantityRef = useRef(null);


    const printQRCode = () => {
        const element = document.getElementById("listQRCode");
        if (element) {
            var windowContent = '<!DOCTYPE html>';
            windowContent += '<html>';
            windowContent += '<head><title>Print QR CODE</title></head>';
            windowContent += '<body>';
            windowContent += element.innerHTML;
            windowContent += '</body>';
            windowContent += '</html>';

            var printWindow = window.open('', '_blank');
            printWindow.document.open();
            printWindow.document.write(windowContent);
            printWindow.document.close();
            printWindow.print();
            // setVisible(false);
            // printWindow.close();
        } else {
            throw new Error('Element with id qrCode not found.');
        }
    };
    let rowCount = 0;
    const rowsToPrint = data.map((item) => { 
        return (
            Array.from({ length: quantity }, (_, index) => {
                rowCount++;
                return (
                    <TableRow
                        key={index}
                        sx={{ '&:last-child td, &:last-child th': { border: 0 } }}
                        // style={{padding: '2px'}}
                    >
                        <TableCell component="th" scope="row" style={{    
                            border: '1px solid #dddddd', 
                            padding: '4px',
                            textAlign: 'center',
                            width: '20px'
                        }}>
                            <Typography
                                variant="subtitle3"
                                noWrap
                                sx={{ fontWeight: '600' }}
                            >
                                {rowCount}
                            </Typography>
                        </TableCell>
                        <TableCell component="th" scope="row" style={{    
                            border: '1px solid #dddddd', 
                            padding: '4px',
                            textAlign: 'center',
                            width: '50px'
                        }}>
                            {
                                item?.device_cd &&  
                                <QRCode
                                    size={256}
                                    style={{ height: "auto", maxWidth: "25%", width: "25%" }}
                                    value={item?.device_cd}
                                    viewBox={`0 0 256 256`}
                                />
                            }
                           
                        </TableCell>
                        <TableCell style={{    
                            border: '1px solid #dddddd', 
                            padding: '4px',
                            textAlign: 'center',
                            width: '100px',
                        }}>
                            <Stack display={'flex'} flexDirection={'row'}>
                                <Grid container spacing={2}>
                                    <Grid item xl={12} md={6} sm={6} style={{ width: '100%', textAlign: 'left' }}>
                                        <Typography
                                            variant="subtitle3"
                                            noWrap
                                            sx={{ fontWeight: '600' }}
                                        >
                                            {t('name_device')}: {item?.device_nm}
                                        </Typography>
                                    </Grid>
                                    <Grid item xl={12} md={6} sm={6} style={{ width: '100%', textAlign: 'left' }}>
                                        <Typography variant="subtitle3" noWrap>
                                            {t('code_device')}: {item?.device_cd}
                                        </Typography>
                                    </Grid>
                                </Grid>
                            </Stack>
                        </TableCell>
                    </TableRow>
                )
            }
        ));
    })

    return (
        <>
            <BootstrapDialog
                open={visible}
                aria-labelledby="customized-dialog-title"
                PaperProps={{ component: 'div', style: { width: '40%' } }}
            >
                <BootstrapDialogTitle
                    onClose={() => {
                        setVisible(!visible);
                        setQuantity(1);
                    }}
                    id="customized-dialog-title"
                >
                    {t('input_quantity_print_list_d')}
                </BootstrapDialogTitle>
                <DialogContent dividers>
                    <Grid container spacing={2}>
                        <Grid item style={{ width: '100%' }} xl={12} md={12} sm={12}>
                            <NumberInput
                                label={t('quantity_category')}
                                valueChange={quantity}
                                size="medium"
                                autoFocus
                                // required
                                // onEnterPress={handleClick}
                                ref={quantityRef}
                                getValue={setQuantity}
                            />
                        </Grid>
                    </Grid>
                </DialogContent>
                <DialogActions style={{ padding: '12px 16px' }}>
                    <ButtonAction
                        onClick={() => {
                            setVisible(!visible);
                            setQuantity(1);
                        }}
                        type={'cancel'}
                        title={t('cancel')}
                    />
                    <Stack direction="row" alignItems="center" justifyContent="space-between" flexWrap={'wrap'}>
                        <Button
                            onClick={() => {
                                printQRCode();
                                setVisible(false);
                                setQuantity(1);
                            }}
                            startIcon={<Iconify icon="material-symbols:check-circle" />}
                            color="primary"
                            variant='outlined'
                            size='small'
                        >
                            {t('comfirm')}
                        </Button>
                    </Stack>
                </DialogActions>
            </BootstrapDialog>

            <Stack id="listQRCode" style={{display: "None"}}>
                <TableContainer component={Paper}>
                    <Table sx={{ minWidth: 650 }} aria-label="simple table" style={{borderCollapse: 'separate', borderSpacing: '0 10px', minWidth: '100%'}}>
                        <TableHead>
                            <TableRow>
                                <TableCell>STT</TableCell>
                                <TableCell>QR Code</TableCell>
                                <TableCell align="right">{t('info')}</TableCell>
                            </TableRow>
                        </TableHead>
                        <TableBody>
                            {rowsToPrint}
                        </TableBody>
                    </Table>
                </TableContainer>
            </Stack>
        </>
    )
}

export default PrintsQRCodeModal;